/** Possible states of the ATC tool */
export var ToolState;
(function (ToolState) {
    ToolState[ToolState["Ready"] = 0] = "Ready";
    ToolState[ToolState["Previewing"] = 1] = "Previewing";
    ToolState[ToolState["Deleting"] = 2] = "Deleting";
})(ToolState || (ToolState = {}));
